/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connection: NonNullable<unknown> }} Audit_Details_Private_Model_Connection_Deleted_DescInputs */



/**
* | output |
* | --- |
* | "The model connection \"{connection}\" was removed with all its models." |
*
* @param {Audit_Details_Private_Model_Connection_Deleted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_private_model_connection_deleted_desc = /** @type {((inputs: Audit_Details_Private_Model_Connection_Deleted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Private_Model_Connection_Deleted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Modell-Verbindung "${i?.connection}" wurde mit allen ihren Modellen entfernt.`)
	return /** @type {LocalizedString} */ (`The model connection "${i?.connection}" was removed with all its models.`)
});